import { render, staticRenderFns } from "./headKnowledge.vue?vue&type=template&id=1af842e4&scoped=true&"
import script from "./headKnowledge.vue?vue&type=script&lang=js&"
export * from "./headKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./headKnowledge.vue?vue&type=style&index=0&id=1af842e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af842e4",
  null
  
)

export default component.exports